new Swiper(".card-wrapper", {
  // Optional parameters
  loop: false,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },

  dynamicBullets: true,
  // Default parameters
  slidesPerView: 3,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 8,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 8,
      spaceBetween: 15,
    },
    1200: {
      slidesPerView: 12,
      spaceBetween: 15,
    },
  },
});
